import * as ReturnCodesConstants from '../../constants/ReturnCodesConstants'
const apiUtils = {
  isOk: (res) => {
    return res.data.code === ReturnCodesConstants.SUCCESS_CODE
  },
  getDataFormResponse: (res) => {
    const isOk = apiUtils.isOk(res)
    if (!isOk) {
      return
    }
    return res.data.data
  },
  getDataFormCodeResponse: (res) => {
    const isOk = apiUtils.isOk(res)
    if (!isOk) {
      return
    }
    return res.data
  },
  getPageDataFormResponse: (res) => {
    const isOk = apiUtils.isOk(res)
    if (!isOk) {
    }
    return {
      data: res.data.data.dataList,
      pageTotal: res.data.data.totalRecord,
      pageSize: res.data.data.pageSize,
      pageCount: res.data.data.pageCount,
      pageNum: res.data.data.pageNum
    }
  },
  getNewDataSetList: (newDataList) => {
    let userIdLists = []
    let number
    let num = 3
    if (newDataList.length === 0) {
      userIdLists.push([{nodeId: 0}])
    } else {
      // 当长度小于要分割的长度，直接存入数组中
      if (newDataList.length > num) {
        if (newDataList.length % num > 0) {
          number = Math.ceil(newDataList.length / num)
        } else {
          number = newDataList.length / num
        }
        // 循环把分割的数组存入 userIdLists 中
        for (let i = 0; i < number; i++) {
          let userIds = []
          // 最后一个数组长度不定
          if (i !== number - 1) {
            for (let j = 0; j < num; j++) {
              userIds.push(newDataList[(i * num + j)])
            }
          } else {
            for (let j = 0; j < newDataList.length - (i * num); j++) {
              userIds.push(newDataList[(i * num + j)])
            }
          }
          userIdLists.push(userIds)
        }
      } else {
        userIdLists.push(newDataList)
      }
    }
    return userIdLists
  }
}
export default apiUtils



// WEBPACK FOOTER //
// ./src/common/utils/apiUtils.js